import React from "react";
import Modal from "components/Modal";
import RescheduleBody from "./RescheduleBody"

export default ({ open, toggler, classes, ...props }) => {
  return (
    <Modal
      open={open}
      maxWidth="sm"
      handleClose={toggler}
      title="Reschedule Event "
      className={{
        dialogRoot: classes.dialogRoot
      }}

    >
      <RescheduleBody {...props} toggler={toggler} event={open} />
    </Modal>
  )
}